"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiPlaceholder = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
/**
 * 문서·예제에서 실제 UI가 들어갈 자리를 대신하는 장식용 박스.
 * 높이·배경·모서리는 소비처가 CSS custom property로 직접 설정한다.
 * 슬롯에는 치수 같은 짧은 안내 텍스트를 넣으며, 가운데에 앉는다.
 */
let UiPlaceholder = class UiPlaceholder extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <div class="placeholder" aria-hidden="true"><slot></slot></div>
    `;
    }
};
UiPlaceholder.styles = (0, lit_1.css) `
    :host {
      --ui-placeholder-height: var(--size-80);
      --ui-placeholder-background-color: var(--primary-subtle-color);
      --ui-placeholder-border-radius: var(--radius-large);

      display: block;
    }

    .placeholder {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: var(--ui-placeholder-height);
      box-sizing: border-box;
      border: var(--border-transparent);
      border-radius: var(--ui-placeholder-border-radius);
      background: var(--ui-placeholder-background-color);
    }
  `;
UiPlaceholder = __decorate([
    (0, decorators_js_1.customElement)('mm-ui-placeholder')
], UiPlaceholder);
exports.UiPlaceholder = UiPlaceholder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidWktcGxhY2Vob2xkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1aS1wbGFjZWhvbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRWpEOzs7O0dBSUc7QUFFSSxJQUFNLGFBQWEsR0FBbkIsTUFBTSxhQUFjLFNBQVEsZ0JBQVU7SUF1QjNDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztLQUVWLENBQUE7SUFDSCxDQUFDOztBQTFCTSxvQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQW9CbEIsQ0FBQTtBQXJCVSxhQUFhO0lBRHpCLElBQUEsNkJBQWEsRUFBQyxtQkFBbUIsQ0FBQztHQUN0QixhQUFhLENBNEJ6QjtBQTVCWSxzQ0FBYSJ9